/* eslint-disable no-underscore-dangle */

// As seen on --> https://github.com/vuejs/vue/issues/1829#issuecomment-624193371
/** Turns off watchers for any code executed within the function passed */
function withoutWatchers(this: any, fnWithoutWatchers: ()=>void) {
  let watchers = {} as any;
  if (this?._watchers) {
    watchers = this._watchers.map((watcher: any) => ({ cb: watcher.cb, sync: watcher.sync }));
    Object.keys(this._watchers).forEach((key: any) => {
      this._watchers[key] = Object.assign(this._watchers[key], { cb: () => null, sync: true });
    });
  }

  fnWithoutWatchers();

  if (this?._watchers) {
    Object.keys(this._watchers).forEach((key: any) => {
      this._watchers[key] = Object.assign(this._watchers[key], watchers[key]);
    });
  }
}

export default withoutWatchers;
